import React from 'react';
import styled from 'styled-components';
import useFormattingMap from '@ubeya/shared-web/hooks/useFormattingMap';
import { Tooltip, TooltipBody } from '@ubeya/shared-web/components';

const TotalText = styled.div`
  font-weight: 600;
`;

const TotalClientRateRenderer = ({ rowData: { clientWageTotal, payroll } }) => {
  const formattingMap = useFormattingMap();

  return (
    <Tooltip
      body={<TooltipBody body={payroll?.calculationString} maxWidth={400} center={false} />}
      disabled={!payroll?.calculationString}>
      <TotalText>{clientWageTotal !== 0 && formattingMap.currency(clientWageTotal)}</TotalText>
    </Tooltip>
  );
};

export default TotalClientRateRenderer;
